import { OilLampIcon } from './OilLampIcon';

/**
 * author: Michael Richins
 * id 790DAFDA-8291-47F5-A5B9-9563AE201832
 * name oil-lamp
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/oil-lamp.svg
 * tags
 */
export const GenieLampIcon = OilLampIcon;
export default GenieLampIcon